import React from 'react';
import { connect } from 'react-redux';

import ContactUsComponent from '../components/app/contactUs/Contact';

import * as actions from '../actions/contact-us';

const ContactUs = (props) => {
  return (
    <ContactUsComponent {...props}/>
  );
};

export default connect(({ contactUs }) => contactUs, actions)(ContactUs);

